import React from "react";
import { useParams } from "react-router-dom";
import { useModuleAdmin } from "../moduleServices";

import ManageMediaAccess from "../../common/ManageMediaAccess";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

const ManageModuleAccess = () => {
  const { id } = useParams();
  const module = useModuleAdmin(id);

  if (module.isLoading) {
    return <PanelLoadingIndicator />;
  }

  return <ManageMediaAccess media={module.data} />;
};

export default ManageModuleAccess;
